import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

interface ICitiesSelectProps {
  selectedCities: string[];
  setSelectedCities: (cities: string[]) => void;
}

export const CitiesSelect = ({
  selectedCities,
  setSelectedCities,
}: ICitiesSelectProps) => {
  const [newCity, setNewCity] = useState<string>("");
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`internaltoolsPage.checkOwnerArea.${key}`);

  const handleAddCity = () => {
    const _city = newCity.trim();
    if (_city === "" || selectedCities.includes(_city)) {
      setNewCity("");
      return;
    }
    setSelectedCities([...selectedCities, _city]);
    setNewCity("");
  };

  const handleRemoveCity = (city: string) => {
    setSelectedCities(selectedCities.filter((c) => c !== city));
  };
  return (
    <div className="cities-select">
      <h3>{t("cities_title")}</h3>
      {selectedCities.map((city) => (
        <div className="city-item" key={city}>
          <button
            className="btn btn-border btn-border-red"
            onClick={() => handleRemoveCity(city)}
          >
            {t("remove")}
          </button>
          <span>{city}</span>
        </div>
      ))}
      <div className="city-input">
        <input
          type="text"
          value={newCity}
          onChange={(e) => setNewCity(e.target.value)}
        />
        <button className="btn btn-border" onClick={handleAddCity}>
          {t("add")}
        </button>
      </div>
    </div>
  );
};
